import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Cad"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.5 6.75H10.5C9.67157 6.75 9 7.42157 9 8.25V17.25H10.5V13.5H13.5V17.25H15V8.25C15 7.42157 14.3284 6.75 13.5 6.75ZM10.5 12V8.25H13.5V12H10.5ZM19.5 17.25H16.5V6.75H19.5C21.1569 6.75 22.5 8.09315 22.5 9.75V14.25C22.5 15.9069 21.1569 17.25 19.5 17.25ZM18 15.75H19.5C20.3284 15.75 21 15.0784 21 14.25V9.75C21 8.92157 20.3284 8.25 19.5 8.25H18V15.75ZM7.5 17.25H3C2.17157 17.25 1.5 16.5784 1.5 15.75V8.25C1.5 7.42157 2.17157 6.75 3 6.75H7.5V8.25H3V15.75H7.5V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Cad.vue"]]);
